import React from 'react'
import iButton from '../assets/iButton.svg'
import LanguageStrings from '../i18n/locales'

const DatePickerInfoStrings = LanguageStrings().Diagnostics.Info

export const getDatePickerInfo = (): JSX.Element => {
  const [isHovered, setIsHovered] = React.useState(false)
  return (
    <span onMouseEnter={() => { setIsHovered(true) }} onMouseLeave={() => { setIsHovered(false) }} style={{ position: 'relative' }}>
      <img className='elementHoverBlue' style={{ position: 'absolute', top: '3px', left: '8px' }} src={iButton} />
      { isHovered ? <span style={{ position: 'absolute', width: 180, backgroundColor: '#ffffff', padding: 6, borderRadius: 4, color: '#000000', fontSize: 13, zIndex: 100, right: '-50px', top: '32px', textTransform: 'initial' }}>{DatePickerInfoStrings.Details}</span> : <></> }
    </span>
  )
}
